import React, {Fragment} from 'react';
import {CallMade} from '@material-ui/icons';
import {BottomContent, MainContent} from 'layouts/commons';
import {EfeLinkButton} from 'components';
import {default as data} from 'commons/defaults/before-start-data.json';
import {Bullet} from 'commons/models';
import EfeBulletList from 'components/efe-bullet-list/EfeBulletList';
import {useAnalytics} from 'hooks/AnalyticsHook';
import {AnalyticsCategories, HistoryRoutes} from 'commons/constants';
import {messageFunctions} from 'commons/utils';

function BeforeStart() {
    const {sendPageView, sendEvent} = useAnalytics();
    const bullets: Array<Bullet> = data;
    React.useEffect(() => {
        sendPageView(HistoryRoutes.BEFORE_START);
        sendEvent(
            AnalyticsCategories.LOGIN,
            messageFunctions.getAnalyticsMessage(AnalyticsCategories.USER, 'Nuevo usuario')
        );
    }, []);
    return (
        <Fragment>
            <MainContent>
                <EfeBulletList bullets={bullets} />
            </MainContent>
            <BottomContent>
                <EfeLinkButton primary path={'/admin/terms-conditions'} endIcon={<CallMade />}>
                    {'Continuar'}
                </EfeLinkButton>
            </BottomContent>
        </Fragment>
    );
}

export default BeforeStart;
